module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-BOOSTER-GREEN-1.d9863c7b.jpg";